import { Avatar } from 'copilot-design-system';
import { useState } from 'react';

import { ContextBarAvatarPopover } from 'src/features/context-bar/ContextBarAvatarPopover';
import { useAppSelector } from 'src/hooks/useStore';
import {
  selectAllCompaniesMap,
  selectClientsMap,
} from 'src/store/clients/types';
import { getInitials } from 'src/utils/UserUtils';

interface ContextBarAvatarProps {
  className?: string;
  entityType: 'client' | 'company';
  entityId: string;
}

export const ContextBarAvatar = ({
  className,
  entityType,
  entityId,
}: ContextBarAvatarProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const companies = useAppSelector(selectAllCompaniesMap);
  const clients = useAppSelector(selectClientsMap);

  const client = entityType === 'client' ? clients.get(entityId) : undefined;
  const company =
    entityType === 'company' ? companies.get(entityId) : undefined;

  let entityName = '';
  let avatarSrc = '';
  let avatarFallbackColor = '#6B7280';

  if (client) {
    entityName =
      `${client.fields.givenName ?? ''} ${client.fields.familyName ?? ''}`.trim();
    avatarSrc = client.fields.avatarImageUrl ?? '';
    avatarFallbackColor = client.fields.fallbackColor ?? '#6B7280';
  } else if (company) {
    entityName = company.fields.name;
    avatarSrc = company.fields.avatarImageURL ?? '';
    avatarFallbackColor = company.fields.fallbackColor ?? '#6B7280';
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        className={`${className ?? ''} border-0 bg-transparent p-0 cursor-pointer inline-flex`}
        onClick={handleClick}
        aria-label={`View ${entityName} profile`}
      >
        <Avatar
          src={avatarSrc}
          fallbackColor={avatarFallbackColor}
          variant="circle"
          text={getInitials(entityName, { twoLetters: true })}
          size="md"
          alt={entityName}
        />
      </button>
      <ContextBarAvatarPopover
        entityType={entityType}
        entityId={entityId}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      />
    </>
  );
};
